import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../../data/testimonials';
export function Testimonials() {
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-213" data-mp="3mf7pges1bkaz">
      <div className="mx-auto w-full max-w-4xl" data-id="element-214" data-mp="3r7sfr6bqff9r">
        <SectionHeading eyebrow="💬 What Dental Professionals Are Saying" title="See Why Dentists Are Using Structured Clinical Systems" data-id="element-215" data-mp="3r9lqawpgujn1" />

        <ul className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-216" data-mp="41hylaclbhwv">
          {testimonials.map(t => <li key={t.name} className="flex h-full flex-col rounded-3xl border border-slate-200 bg-bone p-5 shadow-card sm:p-6" data-id="element-217" data-mp="937bywnac7o4">
              <div className="flex gap-0.5" aria-label="Rated 5 out of 5 stars" data-id="element-218" data-mp="2atshdzsjbxom">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-219" data-mp="2fsvmfk8im3wl" data-mpi={i} />)}
              </div>
              <blockquote className="mt-3 text-[14.5px] leading-relaxed text-slate-700" data-id="element-220" data-mp="1nrq1puxq63c1">
                “{t.quote}”
              </blockquote>
              <div className="mt-auto flex items-center gap-3 pt-5" data-id="element-221" data-mp="1etxjahwpifkf">
                <img src={t.image} alt={t.name} className="h-12 w-12 shrink-0 rounded-full object-cover" loading="lazy" data-id="element-222" data-mp="2bjeufcegktti" />
                <div data-id="element-223" data-mp="22igqsv7xmobg">
                  <p className="text-[14px] font-bold text-navy-950" data-id="element-224" data-mp="22hnrugf7t33v">{t.name}</p>
                  <p className="text-[12px] text-slate-500" data-id="element-225" data-mp="1xk5feg1zo5r4">{t.role}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-9 max-w-md" data-id="element-226" data-mp="r4v3lflmuwsk">
          <CTAButton label="Join the dentists using this system" data-id="element-227" data-mp="m3xlf30mi2r2" />
        </div>
      </div>
    </section>;
}